// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"0297625d","579":"9d20922f","670":"92317493","770":"45337985"}[chunkId] + ".chunk.css";
};